import EventEmitter from 'eventemitter3'
const bus = new EventEmitter()

// 全局广播事件的名称
bus.$events = {
  FORCE_REFRESH_KCHART: 'force-refresh-kchart', // 强制刷新 k 线图
  FORCE_REFRESH_MOUNTAIN: 'force-refresh-mountain', // 强制刷新山脉图
  SHOW_LOGIN: 'show-login-dialog', // 打开登录面板
  SHOW_ACCOUNT_INFO: 'show-account-info', // 打开用户信息界面
  MANUAL_REFRESH_QUOTE: 'manual-refresh-quote', // 点击按钮手动刷新行情
  INTERCEPT_MESSAGE: 'interrupt-message', // 361 中断验证消息
  CHECK_TAB: 'check-tab', // 全局的 tab 切换事件
  DOCUMENT_VISIBLE_CHANGE: 'document-visible-change', // 全局页面隐藏监听
  MANUAL_REFRESH_FUNDAMENTAL: 'manual-refresh-fundamental', // 手动更新，主要指标
  MANUAL_REFRESH_DOM: 'manual_refresh_dom', // 手动刷新 闪电下单
  STOCK_UPDATE: 'when-stock-update', // 当前股票更新
  CLOSE_MESSAGE_BOX: 'close-msg-box', // 股价提醒横幅点击可以关闭消息弹框
  DIRECT_INPUT: 'main-direct-input' // 个股页面直接输入搜索触发
}

export default bus
